import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FaqService } from './faq.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [],
  providers : [FaqService]
})
export class FaqModule { }



// WEBPACK FOOTER //
// ./src/app/shared/components/faq/faq.module.ts